import Cookies from "js-cookie";

const CHECKOUT_TOKEN_PARAM = "token";
const AUTH_TOKEN_KEY = "AUTH-TOKEN";
const STALE_AUTH_KEYS = ["currentTeam", "isAffiliate"];
const IGNORED_TOKEN_PATHS = ["/reset/password"];
const PUBLIC_AUTH_TOKEN_REDIRECT_PATHS = ["/", "", "/sign-in", "/login", "/signup"];

const safelyRun = (callback) => {
  try {
    callback();
  } catch (error) {
    // Storage can be unavailable in some browser privacy modes.
  }
};

const removeCookie = (key) => {
  Cookies.remove(key, { path: "/" });
};

const storeCheckoutToken = (token) => {
  Cookies.set(AUTH_TOKEN_KEY, token, { expires: 7, path: "/" });

  safelyRun(() => {
    window.sessionStorage.setItem(AUTH_TOKEN_KEY, token);
  });

  safelyRun(() => {
    window.localStorage.setItem(AUTH_TOKEN_KEY, token);
  });
};

const clearStaleCheckoutAuthState = () => {
  STALE_AUTH_KEYS.forEach((key) => {
    removeCookie(key);

    safelyRun(() => {
      window.sessionStorage.removeItem(key);
    });

    safelyRun(() => {
      window.localStorage.removeItem(key);
    });
  });
};

const getCheckoutRedirectPath = (url) => {
  if (PUBLIC_AUTH_TOKEN_REDIRECT_PATHS.includes(url.pathname)) {
    return "/dashboard";
  }

  return url.pathname;
};

const removeCheckoutTokenFromUrl = (url) => {
  url.searchParams.delete(CHECKOUT_TOKEN_PARAM);
  const search = url.searchParams.toString();
  const cleanUrl = `${getCheckoutRedirectPath(url)}${search ? `?${search}` : ""}${url.hash}`;
  window.history.replaceState(window.history.state, document.title, cleanUrl);
};

export const bootstrapCheckoutAutoLoginToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const url = new URL(window.location.href);
  if (IGNORED_TOKEN_PATHS.some((path) => url.pathname.includes(path))) {
    return null;
  }

  const token = url.searchParams.get(CHECKOUT_TOKEN_PARAM);
  if (!token) {
    return null;
  }

  storeCheckoutToken(token);
  clearStaleCheckoutAuthState();
  removeCheckoutTokenFromUrl(url);

  return token;
};

bootstrapCheckoutAutoLoginToken();
